export default __webpack_public_path__ + "static/media/bakanlik-yatay-kirmizi.21011b5c.png";